import { useLocation } from 'react-router-dom';
import { useAppSelector } from '../store/storeTypes';
import chevronLeftWhite from '../img/icons/ChevronLeftWhite.svg';
import chevronLeft from '../img/icons/ChevronLeft.svg';
import { freshRelevance, gtmEvent } from '../helpers/commonHelpers';
import { useConfig } from '../helpers/useConfig';

const restaurantSelectionEndPoints = ['/', '/collection/', '/delivery/', '/collection', '/delivery'];

const Hero = ({
  backgroundColour,
  title,
  titleStyles,
  title1,
  title2,
  title3,
  subtitle,
  ctaCopy,
  copyColour,
  headerType,
  titleColour,
  subTitleColour,
  backButton,
  allergens,
  heroWidthHalf,
  heroPaddingSize,
  paddingTop,
  customStyles,
  isSmallerTitle,
  bgImage,
  extraVerticalPadding,
  isCustomise,
  isPayment,
  isSticky,
  isBasket,
  inApp,
  disableBackButton,
  heroSectionRef,
  refs
}) => {
  const config = useConfig();
  const { pathname } = useLocation();
  const isDelivery = useAppSelector(state => state.basket.isDelivery);

  const Title = (title) => {
    const regexStr = /.?[PF]/;
    return title.split('\n').map((str, i) => {
      if (str.match(regexStr)) {
        return (
          <span key={'title-' + i} style={{ display: 'block' }}>
            <span className="special">{str.charAt(0)}</span>
            {str.substring(1)}
          </span>
        );
      } else {
        return <span key={'title-' + i} style={titleStyles}>{str}</span>;
      }
    });
  };

  const allergenClicked = () => {
    gtmEvent(isDelivery ? 'Delivery_Allergens_Link' : 'Collection_Allergens_Link');
    freshRelevance('pageChange', null, { 'sendBeacon': true });
  };

  const restaurantSelectionPage = restaurantSelectionEndPoints.includes(pathname);

  const setRef = (r) => {
    if (refs?.current) {
      refs.current.heroBackButtonRef = r;
    }
  }
  return (
    <section
      data-testid="hero-section"
      className={`section hero 
        ${extraVerticalPadding ? 'extra-vertical-padding' : ''}
        ${headerType ? headerType : ''} 
        ${customStyles ? customStyles : ''}
        ${copyColour ? `has-text-${copyColour}` : ''}
        ${backgroundColour ? `has-background-${backgroundColour}` : ''}
        ${heroPaddingSize ? heroPaddingSize : ''}
        ${isCustomise ? 'customise' : ''}
        ${(!inApp && isPayment) ? 'payment' : ''}
        ${pathname?.includes('login') || pathname?.includes('forgottenPassword') || pathname?.includes('verifyemail') || pathname?.includes('resetPassword') || pathname?.includes('passwordResetConfirmation') ? 'login' : ''}
        ${isSticky ? 'isSticky' : ''}
      `}
      ref={heroSectionRef}
    >
      {
        !inApp && !isBasket && bgImage &&
        <>
          {bgImage}
        </>
      }
      <div className={`hero-body is-relative ${backButton ? 'has-back-button' : ''} ${inApp ? 'in-app' : ''} ${(restaurantSelectionPage) ? 'restaurant-search' : ''}`} style={{ ...paddingTop ? { paddingTop } : {}, overflow: 'hidden' }}>
        <div className="hero-content is-fluid" style={{position: 'static'}}>
          <div className="is-centered has-text-centered m-0" style={{position: 'relative'}}>

            {backButton && !inApp &&
              <button
                ref={setRef}
                onClick={backButton}
                className={'back-btn'}
                disabled={disableBackButton}
              >
                <img src={isPayment || isBasket ? chevronLeft : chevronLeftWhite} alt="Back button icon" style={{ width: 24, height: 24 }} />
                <span style={{ color: isPayment || isBasket ? '#1c1a1a' : 'white' }} className='pl-2 back-btn-text'>Back</span>
              </button>
            }

            <div className={`title-hero ${heroWidthHalf ? 'is-6' : backButton ? 'is-10' : 'is-12'} p-0`}>
              <div className="block content is-flex-direction-column is-justify-content-center is-align-items-center">
                {(title || title1) && (
                  <h1
                    data-testid="hero-title"
                    className={`
                      title is-spaced is-uppercase
                      ${titleColour ? 'has-text-' + titleColour : ''}
                      ${isSmallerTitle ? 'is-smaller-title' : ''}
                      ${isBasket ? 'is-basket' : ''}
                      ${(inApp && !restaurantSelectionPage) ? 'in-app' : ''}
                      ${(restaurantSelectionPage) ? 'restaurant-search' : ''}
                      
                    `}
                    style={{ lineBreak: 'strict' }}
                  >
                    {Title(title || title1)} <span style={{ whiteSpace: 'nowrap' }}>{title2}</span>
                  </h1>
                )}
                {(title3 && !inApp) && (
                  <h2 className={`title is-size-2 is-spaced ${titleColour && 'has-text-' + titleColour}`} style={{ lineBreak: 'strict' }}>
                    {Title(title3)}
                  </h2>
                )}
                {subtitle && (
                  <h4
                    data-testid="hero-subtitle"
                    className={`subtitle oop-in-app
                    ${allergens || ctaCopy ? '' : 'mb-0-desktop mb-0-tablet mb-0-mobile'}

                    ${subTitleColour ? 'has-text-' + subTitleColour : ''}`}
                  >
                    {subtitle}
                  </h4>
                )}
                {(allergens || ctaCopy) && <div className='allergen-link-wrapper is-flex-direction-column'>

                  {allergens && (
                    <div>
                      <a onClick={allergenClicked} className={'titleLink hero-allergen'} target='_blank' href={config?.BRAND === 'PE' ? 'https://www.pizzaexpress.com/allergens-and-nutritionals' : 'https://www.milano.ie/allergens-and-nutritionals'} >
                        Allergen Information
                      </a>
                    </div>
                  )}
                </div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
